import { ApiLaydownLogRow } from "./ApiLaydownLogRow";
export class ApiLaydownLogFilterParams {
    _ALL?: string;
    jobNumber?: string;
    contact?: string;
    space?: string;
    dateIn?: string | null;
    estDateOut?: string | null;
    dateOut?: string | null;
    loggedBy?: string;
    storageFacility?: string;
  
    public constructor(init?: Partial<ApiLaydownLogRow>) {
        if (init) {
          this.jobNumber = init.jobNumber;
          this.contact = init.contact;
          this.space = init.space;
          this.dateIn = init.dateIn;
          this.estDateOut = init.estDateOut;
          this.dateOut = init.dateOut;
          this.loggedBy = init.loggedBy;
          this.storageFacility = init.storageFacility;
        }
    }
  
}